"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const i18next_icu_1 = __importDefault(require("i18next-icu"));
const react_i18next_1 = require("react-i18next");
const initializeTranslations = (languages, defaultLanguage) => {
    i18next_1.default
        .use(react_i18next_1.initReactI18next)
        .use(new i18next_icu_1.default({
        parseErrorHandler: (err, key, res, options) => {
            /* eslint-disable no-console */
            if (!__DEV__) {
                return '';
            }
            const groupKey = `Error details for faulty translation: ${key}`;
            console.group(groupKey);
            console.info('The ICU library has problems parsing a select statement when the select keys contain special characters like %o.', ['.']);
            console.log({ key, res, options });
            console.error(err);
            console.groupEnd();
            return null === res ? '' : 'Faulty translation detected!';
            /* eslint-enable no-console */
        },
    }))
        .init({
        lng: defaultLanguage,
        fallbackLng: defaultLanguage,
        debug: __DEV__,
        resources: languages,
    });
};
exports.default = initializeTranslations;
